import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import newsReducer from "./news/newsSlice.js";
import noticesReducer from "./notices/noticesSlice.js";
import friendsReducer from "./friends/friendsSlice.js";
import userReducer from "./user/userSlice.js";
import favoritesReducer from "./favorites/favoritesSlice.js";
import userPetsReducer from "./pets/petsSlice.js";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  user: userReducer,
  news: newsReducer,
  notices: noticesReducer,
  friends: friendsReducer,
  favorites: favoritesReducer,
  userPets: userPetsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
